import { createContext, useContext } from "react";

/** True when rendering under IndividualComponentLoader (detail page, not home carousel). */
export const IndividualPageLayoutContext = createContext(false);

export function useIndividualPageLayout(): boolean {
  return useContext(IndividualPageLayoutContext);
}
